import React, { useRef, useState } from "react";
import { Upload } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ImageUploadField({ value, onChange, placeholder = "Görsel URL", compact = false }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const fileInput = useRef(null);

  async function upload(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    event.target.value = "";
    setError("");
    if (file.size > 5_000_000) {
      setError("Görsel en fazla 5 MB olabilir.");
      return;
    }
    const form = new FormData();
    form.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/media/images", form);
      onChange(data.url);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setUploading(false);
    }
  }

  return (
    <div>
      <div className="flex items-center gap-2 min-w-0">
        <input className="input min-w-0 flex-1" value={value || ""} placeholder={placeholder}
               onChange={(event) => onChange(event.target.value)} />
        <button type="button" onClick={() => fileInput.current?.click()} disabled={uploading}
                className="inline-flex shrink-0 items-center gap-1.5 border border-slate-200 bg-white px-3 h-10 text-sm text-slate-700 hover:bg-slate-50 disabled:opacity-60">
          <Upload className="w-4 h-4" /> {uploading ? "Yükleniyor" : "Yükle"}
        </button>
        <input ref={fileInput} type="file" accept="image/jpeg,image/png,image/webp" className="sr-only"
               onChange={upload} disabled={uploading} />
      </div>
      {error && <div className="text-xs text-red-600 mt-1">{error}</div>}
      {!compact && value && <ImagePreview url={value} />}
    </div>
  );
}

function ImagePreview({ url }) {
  const [failedUrl, setFailedUrl] = useState("");
  if (failedUrl === url) return <div className="text-xs text-amber-700 mt-1">Görsel bağlantısı açılamıyor.</div>;
  return <img src={url} alt="Yüklenen görsel önizlemesi" className="mt-2 max-h-28 max-w-full border border-slate-200 object-contain"
              onError={() => setFailedUrl(url)} />;
}
